<template>
  <section :id="['container-' + index + '-' + titleData.type]" :class="['container-' + titleData.type]">
    <div class="container-fluid container-title-image">
      <div class="row title-image-row">
        <div class="col px-0">
          <div class="title-image" v-if="titleData.config.titleImage">
            <img :src="`${titleData.config.titleImage}`" alt="" />
          </div>
        </div>
      </div>
		</div>
    <div v-if="titleData.config.objectTitle" class="title-headline">
			<div class="container-lg">
				<div class="row">
					<h1 class="col-12">{{ titleData.config.objectTitle }}</h1>
				</div>
			</div>
		</div>
  </section>
</template>

<script>
export default {
  props: {
    titleData: {
      type: Object,
    },
    index: {
      type: Number,
    },
    mainSettings: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/titleComponent.scss";
</style>